export default {
  // 页面标题和欢迎信息
  welcome: {
    title: 'Welcome back, {name}！',
    titleWithoutName: 'Welcome back！',
    wave: 'hello'
  },
  
  // 按钮和操作
  actions: {
    createCampaign: 'Create a campaign'
  },
  
  // 页面描述
  description: 'View your campaign reports and analytics',
  
  // 通用状态
  status: {
    loading: 'Loading...',
    error: 'Error occurred',
    success: 'Success'
  }
};
